import React from "react";
export default class Spinner extends React.Component {
    render() {
        return (
            <div>
                <div className="spinner">
                </div>
                <i className="fa fa-cog fa-spin loader"></i>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/utility/spinner.jsx